import { render } from "./MypagePopup.vue?vue&type=template&id=f09607ca"
import script from "./MypagePopup.vue?vue&type=script&lang=js"
export * from "./MypagePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__